export default class BaseURL {
	// return window's URL, minus anything after the slash (as the developer zoo adds stuff there)
	static getBaseURL(): string {
		const hrefSplit = window.location.href.split("/");
		let baseURL = "";
		for (let i = 0; i < hrefSplit.length - 1; i++) {
			baseURL += hrefSplit[i];
			if (i < hrefSplit.length - 2) {
				baseURL += "/";
			}
		}
		return baseURL;
	}
}
